<script lang="ts">
  import type { Snippet } from 'svelte';
  import { CREATOR_TRACK_SUBMISSION } from '$lib/features';
  let { children }: { children: Snippet } = $props();
</script>

<div class="auth-layout">
  <main class="auth-box">
    <a href="#/" class="auth-brand" aria-label="Beat Duel home">Beat Duel</a>
    <!-- Creator-submission wording returns with the feature (decision 114). -->
    {#if CREATOR_TRACK_SUBMISSION}
      <p class="auth-tagline">Submit your tracks. Climb the standings. Grow your audience.</p>
    {:else}
      <p class="auth-tagline">Pick songs. Win duels. Climb the standings.</p>
    {/if}
    {@render children()}
  </main>
</div>

<style>
  .auth-layout {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }
  .auth-box {
    width: 100%;
    max-width: 480px;
  }
  .auth-brand {
    white-space: nowrap;
    text-align: center;
    display: block;
    font-size: 2.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--pink) 0%, var(--purple) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 0.25rem;
  }
  .auth-tagline {
    color: var(--text-muted);
    font-size: 1rem;
    text-align: center;
    margin-bottom: 2rem;
  }
</style>
